import React from 'react'

function Loading() {
    return (
        <div className="knsl-preloader-frame">
            <div className="knsl-preloader">
                <img src="assets/img/logo.svg" alt="Kinsley"/>
                <div className="knsl-preloader-progress">
                    <div className="knsl-preloader-bar"></div>
                </div>
                <div><span className="knsl-preloader-number" data-count="101">0</span>%</div>
            </div>
        </div>
    );
}

export default Loading